import {
  ELEMENT_BLOCKQUOTE,
  ELEMENT_UL,
  ELEMENT_OL,
  ELEMENT_LI,
} from "./constants";

import type { BlockElement } from "./types";
import type { PlateRenderElementProps } from "@udecode/plate-core";

export interface TextEditorElementProps extends PlateRenderElementProps {
  element: BlockElement;
}

export function TextEditorElement({
  attributes,
  children,
  element,
  nodeProps,
}: TextEditorElementProps) {
  switch (element.type) {
    case ELEMENT_BLOCKQUOTE:
      return (
        <blockquote {...attributes} {...nodeProps}>
          <p>{children}</p>
        </blockquote>
      );
    case ELEMENT_UL:
      return (
        <ul {...attributes} {...nodeProps}>
          {children}
        </ul>
      );
    case ELEMENT_OL:
      return (
        <ol {...attributes} {...nodeProps}>
          {children}
        </ol>
      );
    case ELEMENT_LI:
      return (
        <li {...attributes} {...nodeProps}>
          {children}
        </li>
      );
    default:
      return (
        <p {...attributes} {...nodeProps}>
          {children}
        </p>
      );
  }
}
